<template>
  <!-- drawer report point add -->
  <el-drawer
    :title="editorText + '记录要点'"
    :visible.sync="dialogVisible"
    custom-class="zyyj-dialog"
    direction="rtl"
    :show-close="false"
    @open="handleOpen"
  >
    <el-form label-width="120px" :rules="rules" ref="form" :model="form">
      <el-row>
        <el-col :span="24">
          <el-form-item label="记录要点" prop="point">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 9 }"
              v-model.trim="form.point"
              :maxlength="100"
              placeholder="不超过100字"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="计分规则" prop="rule">
            <el-select
              placeholder="请选择"
              v-model="form.rule"
              style="width: 80%"
              popper-class="long-select"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in ruleOptions"
                :key="item.id"
                :label="
                  (_.filter(identify.rules, {
                    type: item.ruleType,
                  })[0] &&
                  _.filter(identify.rules, { type: item.ruleType })[0].name) +
                    item.ruleConfigName +
                    '（' +
                    item.ruleDec +
                    '）'
                "
                :value="item.id"
              >
                <el-tooltip placement="top" popper-class="special-tooltip">
                  <div slot="content">
                    {{
                      (_.filter(identify.rules, {
                        type: item.ruleType,
                      })[0] &&
                      _.filter(identify.rules, { type: item.ruleType })[0].name) +
                        item.ruleConfigName +
                        "（" +
                        item.ruleDec +
                        "）"
                    }}
                  </div>
                  <span
                    style="
                      float: right;
                      width: 100%;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                    >{{
                      (_.filter(identify.rules, {
                        type: item.ruleType,
                      })[0] &&
                      _.filter(identify.rules, { type: item.ruleType })[0].name) +
                        item.ruleConfigName +
                        "（" +
                        item.ruleDec +
                        "）"
                    }}</span
                  >
                </el-tooltip>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="drawer-footer">
      <el-button size="small" @click="closeDialog">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :disabled="submitting"
        @click="submitForm('form')"
        >确 定</el-button
      >
    </div>
  </el-drawer>
</template>

<script>
import _ from 'lodash'
// import __ from '@/util/common-utils'
export default {
  props: ['identify', 'visible'],
  data () {
    return {
      rules: {
        rule: [
          { required: true, message: '请选择计分规则', trigger: ['blur', 'change'] }
        ],
        point: [
          { required: true, message: '记录要点不得为空', trigger: 'blur' },
          { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
        ]
      },
      submitting: false,
      form: { id: null, rule: '', point: '' },
      ruleOptions: [],
      isLastSuccessful: false
    }
  },
  computed: {
    _ () {
      return _
    },
    dialogVisible: {
      get () { return this.visible === true },
      set () { this.$emit('update:visible', false) }
    },
    editing () { return this.identify && this.identify.id > 0 },
    editorText () { return this.identify && this.identify.id ? '编辑' : '添加' }
  },
  mounted () {

  },
  methods: {
    handleOpen () {
      this.$refs.form && this.$refs.form.resetFields()
      this.submitting = false
      this.form.point = this.identify.indicatorPoint || ''
      this.form.rule = this.identify.scoringRuleConfigId || ''
      this.ruleOptions = this.identify.ruleOpt
    },

    closeDialog () {
      if (this.isLastSuccessful) {
        this.$emit('edit-result', true)
      }
      this.$emit('update:visible', false)
    },

    xhrUpdate () {
      let realFormData = {
        id: this.identify.id,
        indicatorPoint: this.form.point,
        scoringRuleConfigId: this.form.rule,
        primaryIndicatorId: this.identify.primaryIndicatorId
      }
      this.$xhrPut(`/eval/indicators/config`, realFormData).then(rs => {
        if (!rs) {
          this.submitting = false
        }
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.isLastSuccessful = true
          this.closeDialog()
        } else {
          this.submitting = false
        }
      })
    },

    xhrAdd () {
      let realFormData = {
        indicatorPoint: this.form.point,
        scoringRuleConfigId: this.form.rule,
        primaryIndicatorId: this.identify.primaryIndicatorId
      }
      this.$xhrPost(`/eval/indicators/config`, realFormData).then(rs => {
        if (!rs) {
          this.submitting = false
        }
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.isLastSuccessful = true
          this.closeDialog()
        } else {
          this.submitting = false
        }
      })
    },

    submitForm (formName) {
      this.submitting = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editing ? this.xhrUpdate() : this.xhrAdd()
        } else {
          this.$message.error('请检查输入')
          this.submitting = false
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-select-dropdown.el-popper.long-select {
  max-width: calc(30% - 195px);
}
/deep/ .long-select::-webkit-scrollbar {
  display: none !important;
  width: 0;
  height: 0;
}
</style>

<style>
.special-tooltip{
  max-width: 28% !important;
  text-align: justify;
  text-justify: newspaper;
  word-break: break-all;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/AddReportPoint.vue